import React, { Component, Fragment } from 'react';
import { Checkbox } from 'antd';

import withFormItem from 'components/hocs/withFormItem';

@withFormItem
export default class CheckboxComponent extends Component {
    handleChange = e => {
        this.props.form.setFieldValue(this.props.field.name, e.target.checked);
    }


    render() {
        const { field: { value }, text, additionalText } = this.props;
        
        return (
            <Fragment>
                <Checkbox onChange={this.handleChange} checked={value}>
                    {text}
                </Checkbox>
                {additionalText}
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/form/Checkbox.js